<template>
  <div id="services-page">
    <v-row noGutters>
      <v-col>
        <Breadcrumbs
          :items="breadcrumbs"
        />
      </v-col>
    </v-row>
    <v-row
      noGutters
    >
      <BaseSidebar
        :items="sidebarItems"
        :title="$t('services.pageName')"
      />
      <v-col>
        <router-view
          @changePage="pageToDisplay = $event"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/shared/navigation/Breadcrumbs';
import BaseSidebar from '@/components/shared/navigation/BaseSidebar';
import { mapGetters, mapActions } from 'vuex';
import roles from '@/constants/roles';

export default {
    components: {
        Breadcrumbs,
        BaseSidebar,
    },
    data() {
        return {
            pageToDisplay: 'servicesPage',
        };
    },
    computed: {
        ...mapGetters([
            'breadcrumbs',
            'woTemplate',
            'hasRole',
        ]),
        sidebarItems() {
            const isLabRole = this.hasRole(roles.LABORATORY_TECHNICIAN.value) || this.hasRole(roles.LABORATORY_CHEMIST.value)
                        || this.hasRole(roles.LABORATORY_MICROBIOLOGIST.value) || this.hasRole(roles.LABORATORY_MANAGER.value);

            return [
                {
                    title: ('services.workOrders'),
                    path: { name: 'serviceWorkOrders' },
                    icon: 'WorkOrder.svg',
                },
                {
                    title: ('services.workOrdersTemplate'),
                    path: !isLabRole ? { name: 'workOrdersTemplate' } : null,
                    icon: 'WorkOrderTemplate.svg',
                },
                {
                    title: ('services.assignations'),
                    icon: 'ClientInfo.svg',
                },
                !this.hasRole(roles.SERVICE_TECHNICIAN.value)
                && {
                    title: ('services.billing'),
                    icon: 'Billing.svg',
                    categoryItems: [
                        {
                            title: 'services.fieldServiceBilling',
                            path: !isLabRole ? { name: 'fieldServicebilling' } : null,
                        },
                        {
                            title: 'services.billingLaboratory',
                            path: { name: 'billingLaboratory' },
                        },
                    ],
                },
            ];
        },
    },
    watch: {
        $route() {
            this.buildFromRoute();
        },
    },
    created() {
        this.buildFromRoute();
    },
    methods: {
        ...mapActions({
            emptyBreadcrumbs: 'emptyBreadcrumbs',
            pushBreadcrumb: 'pushBreadcrumb',
        }),
        buildFromRoute() {
            this.emptyBreadcrumbs();

            const currentPath = this.$route.matched[this.$route.matched.length - 1].path.split('/');
            currentPath.shift();
            currentPath.forEach(route => {
                switch (route) {
                    case ':woTemplateId':
                        this.pushBreadcrumb({
                            name: 'siteEditTemplate',
                            text: `${this.woTemplate.title}`,
                            noTranslate: true,
                        });
                        break;
                    case 'extractToCsv':
                        this.pushBreadcrumb({
                            name: 'extractToCsv',
                            text: 'permissions.workOrders.extractToCsv',
                        });
                        break;
                    case 'workOrders':
                        this.pushBreadcrumb({
                            name: 'analysisResults',
                            text: 'permissions.workOrders.analyseResults',
                        });
                        break;

                    default:
                        this.pushBreadcrumb({
                            name: route,
                            text: `${this.pageToDisplay}.${route}`,
                        });
                        break;
                }
            });
        },
    },
};
</script>
